// extracted by mini-css-extract-plugin
export default {"coursesBody":"Courses_coursesBody__ZO3Ih","cardGrid":"Courses_cardGrid__UFLv5"};